import { render } from "./HeroiconsOutlineChatAlt2.vue?vue&type=template&id=5290d954"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChatAlt2.vue"]])

export default __exports__